module.exports = __webpack_public_path__ + "f44569ec9c75867fbe1dc0152cb7c6d5.MP3";